import { HOUSE_CREATION_ORDER } from '../../VUE/src/pages/oni-mansion-game/consts/HouseTraits';
import { House, HOUSE_PINATA_URL, HOUSE_SMALL_PINATA_URL } from '../../VUE/src/pages/oni-mansion-game/entities/House';
import { HousePreviewAnimationConfig } from './animations';
import { HOUSE_PREVIEW_GAME_ASSETS } from './assets';
import { HOUSE_PREVIEW_ATLAS_CONFIG } from './atlas';
// const main_song = new URL('../../VUE/src/pages/oni-mansion-game/assets/sound/music/main_song.mp3', import.meta.url);
import WebFont from 'webfontloader';
import axios from 'axios';
import { TwitterBannerDownload } from '../../VUE/src/pages/oni-mansion-game/components/TwitterBannerDownload';
import { Overlay } from '../../VUE/src/pages/oni-mansion-game/components/Overlay';
import { PlayPauseComponent } from '../../VUE/src/pages/oni-mansion-game/components/PlayPauseComponent';
import { EasterEggTree } from '../../VUE/src/pages/oni-mansion-game/entities/Tree';
const API_URL = 'https://onisquad.gg/api/oni-mansion-twitter-banner';
// const API_URL = 'https://oni-mansion-game-test.herokuapp.com/api/oni-mansion-twitter-banner';
// const API_URL = 'http://localhost:3500/api/oni-mansion-twitter-banner';

export class HousePreviewScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'HousePreviewScene',
    });
  }

  preload() {
    this.small = this.game.canvas.width < 600;
    this.load.rexAwait(async (successCallback, failureCallback) => {
      const { data } = await axios.get(`${API_URL}/${location.href.split('?')[1].split('=')[1]}`);
      this.config = {};
      this.house_data = data;
      this.candle_count = data.attributes.find((item) => item.trait_type === 'Skull Level').value;
      this.haunt_count = data.attributes.find((item) => item.trait_type === 'Tree Level').value;
      data.attributes.forEach((attr) => {
        if (
          !attr.max_value &&
          attr.value &&
          Object.entries(HOUSE_CREATION_ORDER).find((v) => v[0] === attr.trait_type)
        ) {
          this.config[attr.trait_type] = attr.value;
          Object.keys(this.config).forEach((key) => {
            const keyValue = `${key}/${attr.value}`;
            this.load.image(
              keyValue,
              `${(this.small ? 2 : 1) === 1 ? HOUSE_PINATA_URL : HOUSE_SMALL_PINATA_URL}/${key
                .toLowerCase()
                .trim()
                .split(' ')
                .join('_')}/${attr.value}.png`
            );
          });
        }
      });
      this.load.audio('main_song', data.extra.song_url);
      successCallback();
    });
    if (HOUSE_PREVIEW_GAME_ASSETS) {
      // console.log(HOUSE_PREVIEW_GAME_ASSETS);
      HOUSE_PREVIEW_GAME_ASSETS.forEach((image) => {
        this.load.image(image.name, image.image);
      });
    }

    // Atlas
    if (HOUSE_PREVIEW_ATLAS_CONFIG.length > 0) {
      HOUSE_PREVIEW_ATLAS_CONFIG.forEach((value) => {
        if (value.multiatlas) {
          this.load.multiatlas(value.name, value.json);
        } else {
          this.load.atlas(value.name, value.image, value.json);
        }
      });
    }

    this.load.on('complete', () => {});
  }

  async createHouse() {
    // this.config = { ...HOUSE_CREATION_ORDER };
    this.base_house = new House(
      this,
      0,
      0,
      this.config,
      false,
      this.haunt_count,
      this.candle_count,
      this.small ? 2 : 1
    );
    this.base_house.candle_counter.setVisible(false);
    await this.base_house.createTraits(this.config);

    if (this.small) {
      this.scaleResources();
    } else {
      this.twitter_banner_download = new TwitterBannerDownload(
        this,
        1500,
        990,
        this.config,
        this.haunt_count,
        this.candle_count
      );
      this.twitter_banner_download.download_button.setScale(0.7);
    }
    this.soundController();
  }

  scaleResources() {
    const scale = 0.266;
    this.base_house.base_house.setTexture('base_house_small');
    this.base_house.stars.setTexture('stars_small');
    this.base_house.house_sky.setTexture('house_sky_small');
    this.base_house.tree.setPosition(
      Math.floor(this.base_house.tree.x * scale),
      Math.floor(this.base_house.tree.y * scale)
    );
    this.base_house.candles.setPosition(
      Math.floor(this.base_house.candles.x * scale),
      Math.floor(this.base_house.candles.y * scale)
    );
    // this.base_house.setScaleMultiple(scale);
    // this.base_house.setScale(scale);
    // this.base_house.stars.setScale(4);
    // this.base_house.stars.setTileScale(scale);
    // this.base_house.stars.setCrop(0, 0, 510, 260);
    this.base_house.y = Math.floor(window.innerHeight / 2) - Math.floor(this.base_house.base_house.height / 2);
  }

  async create() {
    this.sound.pauseOnBlur = false;
    this.sound.volume = 0.2;
    this.main_song = this.sound.add('main_song', {
      loop: true,
    });
    HousePreviewAnimationConfig.forEach((animConfig, index) => {
      animConfig.animations.forEach((animation) => {
        this.anims.create({
          key: animation.name,
          frameRate: animation.frameRate,
          frames: this.anims.generateFrameNames(animConfig.atlas, {
            prefix: animation.key,
            start: 0,
            end: animation.frameLength,
            zeroPad: 2,
          }),
          repeat: animation.repeat,
        });
      });
    });

    await this.createHouse();
    WebFont.load({
      custom: {
        families: ['BlackBeard'],
      },
    });
  }

  soundController() {
    this.play_pause = new PlayPauseComponent(this);
    if (this.game.device.os.desktop) {
      this.input.on('gameout', (pointer) => {
        this.play_pause.setVisible(false);
      });
      this.input.on('gameover', (pointer) => {
        this.play_pause.setVisible(true);
      });
    }
    const height = this.game.canvas.height / 2;
    this.play_pause.play_pause_button.setPosition(
      this.cameras.main.width - 30,
      height + this.base_house.base_house.height / 2 - 30
    );
    this.input.on('pointerdown', () => {
      if (this.main_song.isPlaying) {
        this.main_song.pause();
      } else {
        if (!this.main_song.isPlaying && !this.main_song.isPaused) this.main_song.play();
        else this.main_song.resume();
      }
      this.play_pause.play_pause_button.setTexture(this.main_song.isPlaying ? 'pause_opensea' : 'play_opensea');
    });
  }
}
